module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABHNCSVQICAgIfAhkiAAAAPBJREFUSIntll0OgyAQhMemVyBwnO3JiieT3oaGQ9AHlSA/FgLaNHESXgjuh7uzAHApISMgDYc1AvI82DoEqOb7oRJGsJiCacXeeJTGuNUAYfFMzFJNaouBS1DKbaQUWpRSIyAzfxdGG5neB+8Ci0FbqQWsioAuNfWgGDwTNnAHzDiwl5yTfdPQQTBgdjKFwFPkgExDYsB4CMWrY2wajgk90xu0SsqlPc0THXtRDZme+6gLLhEn2/iGwzbikof6nktVIzCpPHDAqylypiy/68ML2Ev3yvXKM5MC4F9j1LwbwzGtz8FvrzMjQP76Zvjf6gN2olnQNy7AOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/train/pic_stars_s@2x.png
// module id = 1xMA
// module chunks = 1